import { render } from "./ConfForgPwd.vue?vue&type=template&id=ca7d557a"
import script from "./ConfForgPwd.vue?vue&type=script&lang=js"
export * from "./ConfForgPwd.vue?vue&type=script&lang=js"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__